import * as types from "../actions/actionTypes";
import { I18n } from "react-i18nify";

const initialState = {
  orders: [],
  requesting: false,
  orderSelected: [],
  allSelected: false,
  acceptCancelRequesting: false,
  createOrderRequesting: false,
  orderIdBatch: -1
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_ORDERS:
      return { ...state, requesting: true };
    case types.REQUEST_ORDERS_SUCCESS:
      return { ...state, requesting: false, orders: action.orders };
    case types.APP_FLUSH_DATAS:
      return { ...state, orders: [], requesting: false };
    case types.SELECT_ORDER_BATCH:
      return { ...state, orderIdBatch: action.orderIdBatch };
    case types.SELECT_ORDER: {
      return {
        ...state,
        orderSelected: [...state.orderSelected, action.orderSelected]
      };
    }
    case types.UNSELECT_ORDER:
      return {
        ...state,
        orderSelected: state.orderSelected.filter(
          oSelected => action.orderUnselected.id !== oSelected.id
        ),
        allSelected: false
      };
    case types.SELECT_ALL_ORDER: {
      if (!action.value)
        return { ...state, orderSelected: [], allSelected: false };
      let orderSelected = state.orders.filter(order => {
        if (
          order.status === I18n.t("orderList.orderStatus.orderAwaitValidation")
        )
          return true;
        return false;
      });
      return { ...state, orderSelected: orderSelected, allSelected: true };
    }
    case types.SELECT_MULTIPLE_ORDER: {
      if (!action.value)
        return { ...state, orderSelected: [], allSelected: false };
      let orderList = [];

      orderList = action.orders.filter(order => {
        if (
          order.status === I18n.t("orderList.orderStatus.orderAwaitValidation")
        )
          return true;
        return false;
      });
      return { ...state, orderSelected: orderList, allSelected: true };
    }
    case types.CLEAR_SELECTED_ORDERS:
      return { ...state, orderSelected: [], allSelected: false };
    case types.UPDATE_ORDERS_STATUS: {
      let newOrderList = [];

      state.orders.forEach(order => {
        if (
          action.orderIds.findIndex(orderId => {
            return order.id === orderId;
          }) >= 0
        ) {
          order.status = action.status;
        }
        newOrderList.push(order);
      });
      return { ...state, orders: newOrderList };
    }
    case types.REQUEST_ACCEPT_CANCEL_ORDERS:
      return { ...state, acceptCancelRequesting: true };
    case types.REQUEST_ACCEPT_CANCEL_ORDERS_SUCCESS:
      return { ...state, acceptCancelRequesting: false };
      case types.REQUEST_CREATE_ORDERS:
      return { ...state, createOrderRequesting: true };
    case types.REQUEST_CREATE_ORDERS_SUCCESS:
      return { ...state, createOrderRequesting: false };
    default:
      return state;
  }
};

export default orderReducer;



// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js